import { useTranslation } from "react-i18next";
import {
  AreaStateAggregateType,
  ErrorAndWarning,
} from "@/routes/area-aggregate/types/area-state-aggregate.type";
import { ModulesFirstOfList } from "./types/first-of-list.type";
import { Fragment } from "react";
import { ModulesStatesEnum } from "@/routes/area-aggregate/types/enums/modules-states.enum";
import { moduleColors } from "@/styles/modules-colors";
import { ErrorModuleDetails, ModulesDetails } from "./modules-details";
import tw from "twin.macro";
import { SheetsType } from "./types/sheets.type";

type PushSheet = (view: SheetsType) => void;

const SortedModulesDetails = ({
  areaStateAggregate,
  firstOfList,
  pushSheet,
}: {
  areaStateAggregate: AreaStateAggregateType;
  firstOfList: ModulesFirstOfList;
  pushSheet: PushSheet;
}) => {
  console.log(firstOfList);
  const unfoldedModulesDetails = {
    color: moduleColors.greenBase,
    numberOfModules: areaStateAggregate.numberOfUnfoldedModules,
    modules: areaStateAggregate.unfoldedModules,
    state: ModulesStatesEnum.UNFOLDED,
  };
  const foldedModulesDetails = {
    color: moduleColors.blueBase,
    numberOfModules: areaStateAggregate.numberOfFoldedModules,
    modules: areaStateAggregate.foldedModules,
    state: ModulesStatesEnum.FOLDED,
  };

  const upModulesDetails = {
    color: moduleColors.greenBase,
    numberOfModules: areaStateAggregate.numberOfUpModules,
    modules: areaStateAggregate.upModules,
    state: ModulesStatesEnum.UP,
  };

  const waitingForStateModulesDetails = {
    color: moduleColors.amberBase,
    numberOfModules: areaStateAggregate.numberOfWaitingForStateModules,
    modules: areaStateAggregate.waitingForStateModules,
    state: ModulesStatesEnum.IN_PROGRESS,
  };
  const underMaintenanceModulesDetails = {
    color: moduleColors.greyBase,
    numberOfModules: areaStateAggregate.numberOfUnderMaintenanceModules,
    modules: areaStateAggregate.underMaintenanceModules,
    state: ModulesStatesEnum.UNDER_MAINTENANCE,
  };
  const errorsAndWarningsDetails = {
    errorsAndWarnings: areaStateAggregate.errorsAndWarnings,
    state: ModulesStatesEnum.FAULTY,
    numberOfModules: areaStateAggregate.numberOfFaultyModules,
    color: moduleColors.redBase,
    modules: areaStateAggregate.faultyModules,
  };

  const modulesDetails: {
    color: string;
    numberOfModules: number;
    modules: string[];
    state: ModulesStatesEnum;
    errorsAndWarnings?: ErrorAndWarning[];
  }[] = [
    unfoldedModulesDetails,
    foldedModulesDetails,
    waitingForStateModulesDetails,
    underMaintenanceModulesDetails,
    errorsAndWarningsDetails,
    upModulesDetails,
  ];

  const sortedAscendingModulesDetails = [
    modulesDetails.find(
      (moduleDetails) => moduleDetails.state === firstOfList
    )!,
    ...modulesDetails
      .filter(
        (moduleDetails) =>
          moduleDetails.state !== firstOfList &&
          moduleDetails.numberOfModules > 0
      )
      .sort((a, b) => b.numberOfModules - a.numberOfModules),
  ];

  console.log(sortedAscendingModulesDetails);

  return (
    <div css={[tw`flex flex-col p-5 overflow-y-auto`]}>
      {sortedAscendingModulesDetails.map((moduleDetails) => {
        if (moduleDetails.state === ModulesStatesEnum.FAULTY) {
          return (
            <ErrorModuleDetails
              key={moduleDetails.state}
              errorsAndWarnings={moduleDetails.errorsAndWarnings!}
              pushSheet={pushSheet}
              areaId={areaStateAggregate.areaId}
            />
          );
        }
        return (
          <ModulesDetails
            key={moduleDetails.state}
            color={(moduleDetails as { color: string }).color}
            numberOfModules={moduleDetails.numberOfModules}
            modules={(moduleDetails as { modules: string[] }).modules}
            state={moduleDetails.state}
            pushSheet={pushSheet}
            areaId={areaStateAggregate.areaId}
          />
        );
      })}
    </div>
  );
};

function ModulesListSheetBody({
  areaStateAggregate,
  firstOfList,
  pushSheet,
}: {
  areaStateAggregate: AreaStateAggregateType;
  firstOfList: ModulesFirstOfList;
  pushSheet: PushSheet;
}) {
  const { t: translator } = useTranslation();
  return (
    <Fragment>
      <div tw="px-6 pb-6">
        <p tw="text-sm text-gray-500">
          {areaStateAggregate.numberOfModulesInArea} {translator("canopies")}
        </p>
      </div>
      <SortedModulesDetails
        areaStateAggregate={areaStateAggregate}
        firstOfList={firstOfList}
        pushSheet={pushSheet}
      />
    </Fragment>
  );
}

export default ModulesListSheetBody;
